import { createApi, retry } from '@reduxjs/toolkit/query/react'

import axiosBaseQuery from './baseQuery'

export const ENDPOINTS_TAGS = {
  ROOT: 'ROOT',
  USERS: 'USERS',
  GET_USER: 'GET_USER',
  ROLES_BY_ID: 'ROLES_BY_ID',
  ROLES: 'ROLES',
  APPOINTMENTS: 'APPOINTMENTS',
  TAG: 'TAG',
  GET_CLINIC: 'GET_CLINIC',
  LOCATIONS: 'LOCATIONS',
  BCF_PERSON_TAGS: 'BCF_PERSON_TAGS',
  PERSON: 'PERSON',
  COMMUNICATIONS: 'COMMUNICATIONS',
  WEB_PUSH_REGISTRATION: 'WEB_PUSH_REGISTRATION',
  CUSTOM_FIELDS: 'CUSTOM_FIELDS',
  DRIVER_EARNINGS: 'DRIVER_EARNINGS',
  ELIGIBILITIES: 'ELIGIBILITIES',
  METRO_PLUS_REPRESENTATIVES: 'MetroPlusRepresentatives',
  METRO_PLUS_SEND_TO_RECORDS: 'MetroPlusSendToRecords',
  WASHINGTON_STATE_HISTORY: 'WashingtonStateHistory',
  WASHINGTON_STATE_RECORD: 'WashingtonStateRecord',
  DMP_CASES: 'DMP_CASES',
  ORGANIZATIONS: 'ORGANIZATIONS',
  ORGANIZATION_USERS: 'ORGANIZATION_USERS',
  GET_BENEFITS: 'GET_BENEFITS',
  FORMS: 'FORMS',
  SMS_CAMPAIGNS: 'SmsCampaigns',
  SMS_CAMPAIGN_BY_ID: 'SmsCampaignById',
  LEGACY_SMS_CAMPAIGNS: 'LegacySmsCampaigns',
  LEGACY_SMS_CAMPAIGN_BY_ID: 'LegacySmsCampaignById',
  PERSON_NOTES: 'PERSON_NOTES',
  CHAT_MESSAGES: 'CHAT_MESSAGES',
  TASK_BY_PERSON_ID: 'TaskByPersonId',
  TASK_BY_TASK_ID: 'TaskByTaskId',
  TICKET_BY_ID: 'TicketById',
  ESCALATION: 'Escalation',
  ESCALATION_BY_PERSON_ID: 'EscalationByPersonId',
  GET_VISITED_PROFILES_RECORDS: 'GetVisitedProfilesRecords',
  GET_PINNED_RECORDS: 'GetPinnedRecords',
  EMAIL_TEMPLATES: 'GET_EMAIL_TEMPLATES',
  EMAIL_TEMPLATE_BY_ID: 'EMAIL_TEMPLATE_BY_ID',
  EMAIL_DOMAINS: 'EMAIL_DOMAINS',
  MEMBERSHIP_DOMAIN: 'MEMBERSHIP_DOMAIN',
  POLICIES: 'Policies',
  LIST_BUILDER: 'ListBuilder',
  LIST_BUILDER_BY_ID: 'ListBuilderById',
  LIST_BUILDER_LIST_ITEMS: 'ListBuilderListItems',
}

export const rootApi = createApi({
  reducerPath: 'rootServices',
  baseQuery: retry(axiosBaseQuery(), { maxRetries: 0 }),
  endpoints: () => ({}),
  tagTypes: Object.values(ENDPOINTS_TAGS),
})
